import type { ExtractPlanResponse } from '@vy/api-definition';
import { ExtractedPlanSchema } from '@vy/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useExtractPlan(options?: UseMutationOptions<ExtractPlanResponse, unknown, { file: File }>) {
  return useMutation(async ({ file }) => {
    const api = getPrivateApi();

    const formData = new FormData();
    formData.append('file', file);

    const extractedPlanResponse = await api.extractPlan({ body: formData });

    return ExtractedPlanSchema.parse(extractedPlanResponse);
  }, options);
}
